import { inject, provide, ref, type InjectionKey, type Ref } from 'vue';
import type { ShipmentFormStopsPort } from '@/composables/shipment-form-stops-port';

export type ShipmentFormStopsSession = {
  stopsPort: Ref<ShipmentFormStopsPort | null>;
  registerStopsPort: (port: ShipmentFormStopsPort | null) => void;
};

export const shipmentFormStopsSessionKey: InjectionKey<ShipmentFormStopsSession> =
  Symbol('shipmentFormStopsSession');

export function provideShipmentFormStopsSession(): ShipmentFormStopsSession {
  const stopsPort = ref<ShipmentFormStopsPort | null>(null);

  function registerStopsPort(port: ShipmentFormStopsPort | null) {
    stopsPort.value = port;
  }

  const session: ShipmentFormStopsSession = { stopsPort, registerStopsPort };
  provide(shipmentFormStopsSessionKey, session);
  return session;
}

export function useShipmentFormStopsSession(): ShipmentFormStopsSession | undefined {
  return inject(shipmentFormStopsSessionKey);
}
